var React = require('react');

function IconMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-mail","data-name":"Icon material-mail","d":"M30,6H6A3,3,0,0,0,3.015,9L3,27a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V9A3.009,3.009,0,0,0,30,6Zm0,6L18,19.5,6,12V9l12,7.5L30,9Z","transform":"translate(-3 -6)","fill":"#fff"}));
}

IconMail.defaultProps = {"width":"30","height":"24","viewBox":"0 0 30 24"};

module.exports = IconMail;

IconMail.default = IconMail;
